import { render, staticRenderFns } from "./20201120.vue?vue&type=template&id=7c335ffd&lang=pug&"
var script = {}
import style0 from "./20201120.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c335ffd')) {
      api.createRecord('7c335ffd', component.options)
    } else {
      api.reload('7c335ffd', component.options)
    }
    module.hot.accept("./20201120.vue?vue&type=template&id=7c335ffd&lang=pug&", function () {
      api.rerender('7c335ffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/20201120.vue"
export default component.exports